import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { SubjectService } from 'src/app/services/subject.service';
import { ApplicationInitializationService } from 'src/app/services/application-initialization.service';
import { Router } from '@angular/router';
declare const FB: any; // Declare FB object

@Component({
  selector: 'app-success',
  templateUrl: './success.component.html',
  styleUrls: ['./success.component.scss'],
})
export class SuccessComponent implements OnInit {
  mobileNumber: any;
  accountDetails: any;
  caption: string | number | boolean;
  pageUrl: string | number | boolean;
  imageUrl: any;
  EISMPC: any;
  EPATESHAREOPTION: any;
  constructor(
    private modalController: ModalController,
    private SS: SubjectService,
    private APPINITS: ApplicationInitializationService,
    private route: Router
  ) {
    this.SS.plantATreeAccountDetails.subscribe((accountDetails) => {
      if (accountDetails) {
        this.accountDetails = accountDetails;
      }
    });
    this.EISMPC =
      this.APPINITS.environmentConfig.EINITIATIVE_SOCIAL_MEDIA_POST_CONTENT;
    this.EPATESHAREOPTION = this.APPINITS.environmentConfig.EINITIATIVE_PLANT_A_TREE_EVENT_SHARE_OPTION_ENABLE;
  }

  ngOnInit() { }
  ok() {
    this.dismiss();
  }

  cancel() {
    this.dismiss();
  }

  closePopUpEN() {
    this.dismiss();
  }

  dismiss() {
    // using the injected ModalController this page
    // can "dismiss" itself and optionally pass back data
    // this.SS.resetVerification.next(true)
    this.modalController.dismiss({
      dismissed: true,
    });
  }

  maskNumber(phoneNumber) {
    if (phoneNumber) {
      let cleanedNumber = phoneNumber.replace(/\D/g, '');
      return cleanedNumber.substring(0, 3);
    } else {
      return phoneNumber;
    }
  }
  shareOnLinkedIn(): void {
    setTimeout(() => {
      // Open a new window with the LinkedIn share dialog
      window.open(
        `https://www.linkedin.com/sharing/share-offsite/?url=${this.EISMPC.url}`,
        '_blank'
      );
    }, 500);
  }

  // Function to share on Facebook
  shareOnFacebook(): void {
    let url = 'http://www.facebook.com/sharer.php?u=' + this.EISMPC.url;
    let newwindow = window.open(
      url,
      'name',
      'height=500,width=520,top=200,left=300,resizable'
    );
    if (window.focus) {
      newwindow.focus();
    }
  }

  shareOnTwitter(): void {
    // Open a new window with the Twitter share dialog
    // Set Twitter meta tags
    setTimeout(() => {
      window.open(
        `https://twitter.com/intent/tweet?url=${encodeURIComponent(
          this.EISMPC.url
        )}`,
        '_blank'
      );
    }, 500);
  }

  plantAnotherTree() {
    this.route.navigate(['/plant-a-tree']);
  }
}
